module.exports = __webpack_public_path__ + "static/media/child_usage2.0cab40ec.png";